import { Stack, Switch, TextField } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { getOptions, isDataPresent } from "../../services/services";
import CouponConfigurableLabel from "../CouponConfigurableLabel";
import { useSelector } from "react-redux";
import {
  resetSlabInfo,
  resetMustBuy,
  resetSectionEnabled,
  resetSchemeProductBifurcationsList,
  updateSchemeType,
  updateCouponTypeOptions,
  updateMustBuyActive,
  updateSectionEnabled,
  updateSkipMarketSelection,
  resetAllData,
  updateCouponTitle,
  setPercentageMaxAmount,
} from "../../../../stateManagement/actions/manageCouponActions";
import { ConfirmationPopUp } from "../../../../components/popup/confirmationPopUp";
import { COUPON_TYPE_OPTIONS_VALUE, labelMappings } from "../../utils/utils";
import CouponBox from "../CouponBox";
import CouponRadioSelector from "../CouponRadioSelector/CouponRadioSelector";
import SKUGroupWithTable from "./productSelection/SKUGroupWithTable";
import MustBuy from "./mustBuy/MustBuy";
import ApplicableSlab from "./applicableSlab/ApplicableSlab";
import { isSchemeProductBifurcationsListEmpty } from "./productSelection/service";
import { mustBuyAllminQtyFilled } from "./mustBuy/service";
import { useCouponAlert } from "../../context/CouponAlert";
import { openPopup } from "../../../../stateManagement/actions/popupActions";
import OverAndAboveCheckBox from "./OverAndAboveCheckBox";
import { applyCouponTitleFilter, applyOverAndAboveFilter, isPeriodicWelcome } from "./MarketDetails/configData";
import RequiredFieldIndicator from "../../../../components/popup/requiredField";
import PeriodicUsabilityCheckBox from "./PeriodicWelcomeCheckBox";

/**
 * This component is main parent component for defining the coupoun type , calculation and coupon criteria
 * The confirmation on input change is also handled in this component
 * @returns
 */
function CouponTypeOptions() {
  const [openModal, setOpenModal] = useState<boolean>(false);
  const {
    schemeType,
    couponTypeOption,
    schemeProductBifurcationsList,
    sectionEnabled,
    isOverAndAbove,
    couponEditType,
  } = useSelector((state: any) => state?.manageCoupons?.data);
  console.log(sectionEnabled);
  const { data: mustBuy, active: mustBuyActive } = useSelector(
    (state: any) => state?.manageCoupons?.data?.mustBuy
  );
  const successMethodRef = useRef<() => void>(() => { });
  const { showAlert } = useCouponAlert();

  const schemeTitle: string = useSelector(
    (state: any) => state.manageCoupons?.data.couponTitle
  );
  const handleCouponTypeOptionChange = (value: string) => {
    if (couponTypeOption === value) return;

    if (isDataPresent()) {
      setOpenModal(true);
      successMethodRef.current = () => {
        resetAllData();
        updateCouponTypeOptions(value);
      };
    } else {
      updateCouponTypeOptions(value);
    }
  };

  const handleCouponCalculationChange = async (value: string) => {
    if (schemeType === value) return;

    if (!isSchemeProductBifurcationsListEmpty()) {
      setOpenModal(true);
      successMethodRef.current = () => {
        updateSchemeType(value);
        resetSectionEnabled();
        resetSchemeProductBifurcationsList();
        resetMustBuy();
        resetSlabInfo();
        setPercentageMaxAmount("");
      };
    } else {
      updateSchemeType(value);
    }
  };

  const [couponTitle, setCouponTitle] = useState<string>(schemeTitle);
  const handleCouponTitle = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    setCouponTitle(newValue);
    updateCouponTitle(newValue);
    if (newValue.length >= 60) {
      openPopup("Alert", "Limit Exceeded");
    }
  };

  const handleMustBuySwitch = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (schemeProductBifurcationsList.length === 0) {
      showAlert(labelMappings["coupon-box-diabled-click-alert"], "warning");
      return;
    }
    updateMustBuyActive(event.target.checked);
  };

  const handleSkipThisStep = (e: any) => {
    e.stopPropagation();
    if (schemeProductBifurcationsList.length === 0) {
      showAlert(labelMappings["coupon-box-diabled-click-alert"], "warning");
      return;
    }
    updateMustBuyActive(false);
    updateSectionEnabled({
      ...sectionEnabled,
      mustBuy: false,
      applicableSlab: true,
    });
  };

  useEffect(() => {
    const val = { ...sectionEnabled };
    if (
      schemeType &&
      couponTypeOption &&
      couponTypeOption !== COUPON_TYPE_OPTIONS_VALUE.TOTAL_ORDER_VALUE
    )
      val["schemeProductBifurcationsList"] = true;

    if (applyCouponTitleFilter() && schemeTitle === "") val["schemeProductBifurcationsList"] = false;

    if (
      couponTypeOption !== COUPON_TYPE_OPTIONS_VALUE.ITEM_LEVEL_COUPON &&
      mustBuyActive &&
      schemeProductBifurcationsList.length > 0
    )
      val["mustBuy"] = true;
    else val["mustBuy"] = false;

    if (applyCouponTitleFilter() && schemeTitle === "") val["applicableSlab"] = false;
    else if (
      (couponTypeOption === COUPON_TYPE_OPTIONS_VALUE.TOTAL_ORDER_VALUE ||
        couponTypeOption === COUPON_TYPE_OPTIONS_VALUE.TOTAL_ORDER_WELCOME) &&
      schemeType !== ""
    )
      val["applicableSlab"] = true;
    else if (
      couponTypeOption === COUPON_TYPE_OPTIONS_VALUE.ITEM_LEVEL_COUPON &&
      schemeProductBifurcationsList.length > 0
    )
      val["applicableSlab"] = true;
    else if (
      !schemeProductBifurcationsList ||
      schemeProductBifurcationsList?.length === 0 ||
      (mustBuyActive && !mustBuyAllminQtyFilled()) ||
      (mustBuy.length === 0 && val["applicableSlab"] === false)
    )
      val["applicableSlab"] = false;
    else val["applicableSlab"] = true;

    updateSectionEnabled(val);
  }, [
    schemeType,
    couponTypeOption,
    schemeProductBifurcationsList,
    mustBuy,
    mustBuyActive,
    schemeTitle,
  ]);

  return (
    <div>
      <Stack direction={"column"} gap={"20px"}>
        <CouponBox
          RequiredFieldIndicator={<RequiredFieldIndicator />}
          disabled={!sectionEnabled["couponTypeOptions"]}
          header={
            <CouponConfigurableLabel
              text={"coupon-type-options"}
              style={{ color: "inherit" }}
            />
          }
        >
          <CouponRadioSelector
            options={getOptions("coupon-type-options")}
            handleChange={handleCouponTypeOptionChange}
            selectedValue={couponTypeOption}
          />
          {applyOverAndAboveFilter() && <OverAndAboveCheckBox />}
          {isPeriodicWelcome() && couponTypeOption===COUPON_TYPE_OPTIONS_VALUE.TOTAL_ORDER_WELCOME && <PeriodicUsabilityCheckBox />}
        </CouponBox>

        <CouponBox
          RequiredFieldIndicator={<RequiredFieldIndicator />}
          disabled={!sectionEnabled["couponSchemeType"]}
          header={
            <CouponConfigurableLabel
              text={"coupon-calculation"}
              style={{ color: "inherit" }}
            />
          }
        >
          <CouponRadioSelector
            options={getOptions(
              `coupon-calculation-method-${couponTypeOption}}`
            )}
            handleChange={handleCouponCalculationChange}
            selectedValue={schemeType}
          />
        </CouponBox>

        {applyCouponTitleFilter() &&
          <CouponBox
            RequiredFieldIndicator={<RequiredFieldIndicator />}
            header={
              <CouponConfigurableLabel
                text={"coupon-title"}
                style={{ color: "inherit" }}
              />
            }
          >
            <TextField
              inputProps={{ maxLength: 60 }}
              size="small"
              variant="outlined"
              placeholder={labelMappings["coupon-title-limit"]}
              fullWidth
              value={schemeTitle}
              onChange={handleCouponTitle}
            />
          </CouponBox>
        }


        {couponTypeOption !== COUPON_TYPE_OPTIONS_VALUE.TOTAL_ORDER_VALUE &&
          couponTypeOption !==
          COUPON_TYPE_OPTIONS_VALUE.TOTAL_ORDER_WELCOME && (
            <CouponBox
              RequiredFieldIndicator={<RequiredFieldIndicator />}
              open={couponEditType === "edit"}
              disabled={!sectionEnabled["schemeProductBifurcationsList"]}
              collapsible
              header={
                <CouponConfigurableLabel
                  text={"product-selection"}
                  style={{ color: "inherit" }}
                />
              }
            >
              <SKUGroupWithTable />
            </CouponBox>
          )}

        {couponTypeOption === COUPON_TYPE_OPTIONS_VALUE.ITEM_LEVEL_COUPON ||
          couponTypeOption === COUPON_TYPE_OPTIONS_VALUE.TOTAL_ORDER_VALUE ||
          couponTypeOption === COUPON_TYPE_OPTIONS_VALUE.TOTAL_ORDER_WELCOME ? (
          <></>
        ) : (
          <CouponBox
            disabled={!sectionEnabled["mustBuy"]}
            collapsible
            open={mustBuyActive && sectionEnabled["mustBuy"]}
            header={
              <div>
                <CouponConfigurableLabel
                  text={"must-buy"}
                  style={{ color: "inherit" }}
                />
                <span
                  style={{ margin: "0 10px" }}
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                >
                  <Switch
                    onChange={handleMustBuySwitch}
                    checked={mustBuyActive}
                  />
                </span>
                <span
                  className="must-buy-skip-this-step-btn"
                  onClick={handleSkipThisStep}
                >
                  Skip This Step
                </span>
              </div>
            }
          >
            <MustBuy />
          </CouponBox>
        )}

        <CouponBox
          RequiredFieldIndicator={<RequiredFieldIndicator />}
          open={couponEditType === "edit"}
          disabled={!sectionEnabled["applicableSlab"]}
          collapsible
          header={
            <CouponConfigurableLabel
              text={"applicable-slab"}
              style={{ color: "inherit" }}
            />
          }
        >
          <ApplicableSlab />
        </CouponBox>
      </Stack>
      <ConfirmationPopUp
        message={labelMappings["RESET_DEPENDENT_DATA"]}
        openConfirmModal={openModal}
        setOpenConfirmModal={setOpenModal}
        successMethod={successMethodRef.current}
      />
    </div>
  );
}

export default CouponTypeOptions;
